module.exports = __webpack_public_path__ + "img/mg-content.3ff2ecaf.png";